import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Link, Redirect } from 'react-router-dom'
import { NewExceptionBar } from './NewExceptionBar'
import { useStateValue } from '@State'
import { ProgressBar } from './ProgressBar'

export const SelectAssignments = props => {
  const [currentState, dispatch] = useStateValue()
  const [currentActivities, setCurrentActivities] = useState([])
  const [selectAllCheck, setSelectAllCheck] = useState(false)

  if (currentState.exceptionType === '') {
    return (
      <Redirect
        to={`/instructor/ada_exceptions/${props.match.params.coursenum}/${props.match.params.studentid}/`}
      />
    )
  }

  useEffect(() => {
    if (currentState.exceptionType === 'grantExtraTime') {
      setCurrentActivities(currentState.timeLimitRulesList)
    } else {
      setCurrentActivities(currentState.lateRulesList)
    }
  }, [currentState.exceptionType])

  const setCheckAssignment = activity => {
    let tempSelectedAssignments = { ...currentState.selectedAssignments }
    if (activity.id in tempSelectedAssignments) {
      delete tempSelectedAssignments[activity.id]
      setSelectAllCheck(false)
    } else {
      tempSelectedAssignments[activity.id] = activity
      if (
        Object.keys(tempSelectedAssignments).length === currentActivities.length
      ) {
        setSelectAllCheck(true)
      }
    }
    dispatch({
      type: 'updateSelectedAssignments',
      selectedAssignments: tempSelectedAssignments,
    })
  }

  const selectAll = () => {
    let tempSelectedAssignments = {}
    if (!selectAllCheck) {
      currentActivities.map(activity => {
        tempSelectedAssignments[activity.id] = activity
      })
    }
    dispatch({
      type: 'updateSelectedAssignments',
      selectedAssignments: tempSelectedAssignments,
    })
    setSelectAllCheck(!selectAllCheck)
  }

  return (
    <div>
      <ProgressBar createException={false} selectAssignments review={false} />
      <div className="d-flex justify-content-center">
        <NewExceptionBar displayRemoveButton={false} />
      </div>
      <div className="d-flex justify-content-center">
        <div className="panel panel-primary w-75">
          <div
            className="panel-heading pl-2"
            style={{ fontSize: '13pt', height: '40px', paddingTop: '7px' }}
          >
            Assignments
          </div>
          <div className="panel-body">
            <div className="pull-right mr-2 mb-2">
              <span>Select All </span>
              <i
                className={
                  selectAllCheck ? 'far fa-check-square' : 'far fa-square'
                }
                onClick={() => {
                  selectAll()
                }}
              />
            </div>
            {currentActivities.map((activity, idx) => {
              return (
                <button
                  key={idx}
                  onClick={() => {
                    setCheckAssignment(activity)
                  }}
                  className="btn btn-myed btn-default btn-default-myed w-100 d-flex justify-content-left p-1 mb-3"
                >
                  <i
                    className={`mt-1 ml-2 mr-2
                      ${
                        activity.id in currentState.selectedAssignments
                          ? 'far fa-check-square'
                          : 'far fa-square'
                      }`}
                  />
                  {activity.title}
                </button>
              )
            })}
          </div>
        </div>
      </div>
      {Object.keys(currentState.selectedAssignments).length !== 0 ? (
        <Link
          className="btn btn-myed btn-primary btn-primary-myed pull-right"
          to={`/instructor/ada_exceptions/${props.match.params.coursenum}/${props.match.params.studentid}/review`}
        >
          Review
        </Link>
      ) : (
        <button className="btn btn-myed btn-primary btn-primary-myed pull-right" disabled>
          Review
        </button>
      )}
      <Link
        className="btn btn-myed btn-default btn-default-myed pull-right"
        to={`/instructor/ada_exceptions/${props.match.params.coursenum}/${props.match.params.studentid}/new_exception`}
      >
        Back
      </Link>
    </div>
  )
}

SelectAssignments.propTypes = {
  match: PropTypes.object.isRequired,
}
